<p-inputSwitch
  [formControl]="control()"
  [name]="name"
  [inputId]="inputId"
  [tabIndex]="tabIndex"
  [trueValue]="trueValue"
  [falseValue]="falseValue"
  [readonly]="readonly"
  [autofocus]="autofocus"
  [styleClass]="cssClass"
  [ngClass]="'input-switch-size__' + size()"
/>
